import React from 'react';
import { DndProvider } from 'react-dnd';
import { MultiBackend } from 'dnd-multi-backend';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import TocMenu from '../../features/viewCourse/components/TocMenu';
import VisualStructureEditor from '../../features/editCourse/components/VisualStructureEditor';
import { useMenuEditLeftMode } from '../../features/global/hooks';
import { PANEL_MODES } from '../../features/editCourse/editCourseState';

const EditCourseLeftPanel = ({ isExpanded = true }) => {
  const menuEditLeftMode = useMenuEditLeftMode();

  return (
    <>
      {menuEditLeftMode === PANEL_MODES.STRUCTURE ? (
        <DndProvider backend={MultiBackend} options={HTML5toTouch}>
          <VisualStructureEditor isExpanded={isExpanded} />
        </DndProvider>
      ) : (
        <TocMenu isStructureEditMode={false} isExpanded={isExpanded} />
      )}
    </>
  );
};

export default EditCourseLeftPanel;
